'use client';

import Link from 'next/link';
import { useEffect, useState } from 'react';
import { AppConfig } from '@/utils/AppConfig';
import DateLabel from '../date/DateLabel';
import DownloadBtn from '../../../../public/svg/btn-telecharger.svg';
import Image from 'next/image';
import CategoryLabel from '../category/CategoryLabel';
import {
  FfbbsiteAssetsTags,
  FfbbsiteCategories,
  JunctionDirectusFilesFfbbsiteAssetsTags,
  JunctionDirectusFilesFfbbsiteCategories,
} from '@/lib/directus';
import "plyr-react/plyr.css"
import dynamic from 'next/dynamic'
export interface TableAssetItemProps {
  category?: JunctionDirectusFilesFfbbsiteCategories[];
  uploaded_on: string;
  id: string;
  title: string;
  main_tag?: FfbbsiteAssetsTags;
  ffbbsite_assets_tags?: JunctionDirectusFilesFfbbsiteAssetsTags[];
  ffbbsite_asset_tag_parent?: string;
  filesize?: string | number | null;
  hasVideo?: boolean | string;
}

const Plyr = dynamic(() => import("plyr-react"), { ssr: false });

export default function TableAssetItem({
  category,
  uploaded_on,
  id,
  title,
  filesize,
  main_tag,
  ffbbsite_assets_tags,
  ffbbsite_asset_tag_parent,
  hasVideo
}: TableAssetItemProps) {

  const [videoVisible, setVideoVisible] = useState<boolean>(false);

  const categoryItem =
    Array.isArray(category) && category.length > 0 && category[0]?.ffbbsite_categories_id
      ? ((category[0]?.ffbbsite_categories_id as FfbbsiteCategories)?.title as string)
      : null;
  const tagItem =
    main_tag?.name ||
    (Array.isArray(ffbbsite_assets_tags) &&
    ffbbsite_assets_tags.length > 0 &&
    ffbbsite_assets_tags[0]?.ffbbsite_assets_tags_id
      ? ((ffbbsite_assets_tags[0]?.ffbbsite_assets_tags_id as FfbbsiteAssetsTags)?.name as string)
      : null);
  const tagParentItem = ffbbsite_asset_tag_parent || '';

  return (
    <div
      key={id}
      className="flex h-[110px] w-full items-start rounded-md bg-white p-5 lg:mb-0 lg:h-[69px] lg:items-center lg:pl-[83px] lg:pr-[89px]"
    >
      {videoVisible && hasVideo && 
        <div id={'video_'+hasVideo} 
          className="fixed top-0 left-0 z-50 flex h-full w-full items-center justify-center bg-black bg-opacity-50" 
          onClick={(e) => (e.target as HTMLElement).id && (e.target as HTMLElement).id === 'video_'+hasVideo && setVideoVisible(false)} 
          onKeyDown={(e) => (e.target as HTMLElement).id && (e.target as HTMLElement).id === 'video_'+hasVideo && setVideoVisible(false)}
          role={`button`}
          tabIndex={0}>
          <button
              className="absolute top-2 right-2 text-white text-2xl"
              onClick={() => setVideoVisible(false)}
            >
              &times;
            </button>
          <div className="relative w-full max-w-[1000px] h-full">
            <div className="absolute -translate-y-1/2 top-[50%]">
            <Plyr
              source={{
                type: 'video',
                sources: [
                  {
                    src: 'https://api.ffbb.com/assets/'+hasVideo,
                  },
                ],
              }}
              options={{ autoplay: false }}
            />
          </div>
          </div>
        </div>
      }
      <div className="lg:flew-col relative flex w-full flex-col justify-start lg:ml-2 lg:flex-row lg:items-center lg:gap-2.5">
        <div className="mb-5 flex flex-row gap-2 lg:mb-0">
          {categoryItem && (
            <div className="w-36 max-w-40">
              {Array.isArray(category) && category.length > 0 && (
                <CategoryLabel category={categoryItem || ''} />
              )}
            </div>
          )}
          {tagItem && (
            <div className="w-36 max-w-40">
              <CategoryLabel category={tagItem || ''} />
            </div>
          )}
          {tagParentItem && (
            <div className="w-36 max-w-40">
              <CategoryLabel category={tagParentItem || ''} />
            </div>
          )}

          {uploaded_on && (
            <DateLabel isoDate={uploaded_on || ''} styles="text-sm" type="dd/MM/yyyy" />
          )}
        </div>

        <Link
          href={`${AppConfig.directusPublicUrl}/assets/${id}?fs=${filesize||0}`}
          target="_blank"
          className="line-clamp-2 grow text-sm font-bold text-slate-950"
        >
          {title}
        </Link>
        {hasVideo && <button 
          onClick={() => setVideoVisible(true)}
          className="relative antialiased tracking-tight bg-gradient-blue-red-diagonal-light w-[40px] h-[40px] lg:h-[40px] lg:w-[40px] rounded-full flex items-center transition-colors duration-200 h-full text-xs bg-video-icon focus:bg-inherit active:bg-inherit"
          title={`Voir la vidéo`}>
        </button>}
        <Link
          href={`${AppConfig.directusPublicUrl}/assets/${id}?fs=${filesize||0}&download`}
          className="absolute right-0 lg:relative"
        >
          <Image src={DownloadBtn} width={40} height={40} alt={`Télécharger ${title}`} />
        </Link>
      </div>
    </div>
  );
}
